__turbopack_context__.v({
  "block": "block-primary-color-module-scss-module__Z_Y5SW__block",
  "blue": "block-primary-color-module-scss-module__Z_Y5SW__blue",
  "dark_blue": "block-primary-color-module-scss-module__Z_Y5SW__dark_blue",
  "dark_gray": "block-primary-color-module-scss-module__Z_Y5SW__dark_gray",
  "gray": "block-primary-color-module-scss-module__Z_Y5SW__gray",
  "light_blue": "block-primary-color-module-scss-module__Z_Y5SW__light_blue",
  "white": "block-primary-color-module-scss-module__Z_Y5SW__white",
  "yellow": "block-primary-color-module-scss-module__Z_Y5SW__yellow",
});
